<script lang="ts" setup>
import { CACertificateItemType } from "~/modules/certificate/models/CACertificateItemType.enum";
import type { KeystoreCertificate } from "~/modules/certificate/models/KeystoreCertificate.interface";
import ILxcInfo from "~icons/lxc/info";

const props = defineProps<{
  certificate: KeystoreCertificate;
}>();

const { t } = useI18n();

const displayInfoSign: ComputedRef<boolean> = computed(
  () => props.certificate.type === CACertificateItemType.CSR,
);
</script>
<template>
  <div
    v-if="displayInfoSign"
    :title="t('certificates.keystore.csrRequiresUploadCertificate')"
    class="text-warning-700"
  >
    <i-lxc-info width="22" height="22" />
  </div>
</template>
